export default __webpack_public_path__ + "static/media/checktick.c9aa7f5d.svg";